import {useEffect, useState, MutableRefObject, FC, SetStateAction} from "react";
import useClickOutside from "../../hooks/useClickOutside";
import classNames from 'classnames';
import styles from "./styles/Popup.module.scss";

const Popup: FC<{
    open: boolean,
    setOpen: SetStateAction<any>,
    editable: boolean,
    renderPopup: JSX.Element,
    popupClassName?: string,
    wrapperClassName?: string,
    arrowPosition: "top" | "bottom" | "left" | "right",
}> = (props) => {

    const [left, setLeft] = useState<number>(0);

    const ref: MutableRefObject<any> = useClickOutside(() => {
        props.setOpen(false);
    });

    useEffect(() => {
        if (ref?.current) {
            const rect = ref.current?.getBoundingClientRect();
            const l = rect?.width/2 - 150;
            setLeft(l < 0 ? 0 : l);
        }
    }, [props.open]);

    function handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (!props.open && props.editable) {
            props.setOpen(true);
        }
    }

    const wrapperClassName = classNames({
        [styles.container]: true,
        [props.wrapperClassName || ""]: props.wrapperClassName,
    })

    const popupClassName = classNames({
        [styles.popup]: true,
        [props.popupClassName || ""]: props.popupClassName,
    })

    const arrowClassName = classNames({
        [styles.arrow]: true,
        [styles.bottom]: props.arrowPosition === "bottom",
        [styles.top]: props.arrowPosition === "top",
        [styles.left]: props.arrowPosition === "left",
        [styles.right]: props.arrowPosition === "right",
    })

    return <div className={wrapperClassName} ref={ref} onClick={handleClick}>
        {props.open && <div style={{left}} className={popupClassName}>
            <div className={arrowClassName}/>
            {props.renderPopup}
        </div>}
        {props.children}
    </div>
}

export default Popup;
